import React from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';

// Floating support ball — sits above the bottom nav, links into live chat.
const SupportFab = () => (
  <Link
    to="/cskh"
    aria-label="CSKH"
    className="fixed right-4 bottom-24 z-40 w-11 h-11 rounded-full bg-white border border-black/[0.05] shadow-lift flex items-center justify-center active:scale-95 transition-transform"
  >
    <MessageCircle className="w-5 h-5 text-ink" />
  </Link>
);

export default SupportFab;
